import TermsModal from './TermsModal';
export default TermsModal;
